export default __webpack_public_path__ + "static/media/b.76ca579a.png";